import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Pie } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { numbersToPercentage } from '../../../utility/numbersHelper'

import globals from '../../../assets/styles/globals.scss'
import classes from './GenderBreakdownPie.module.scss'

const GenderBreakdownPie = ({ male = 0, female = 0, other = 0 }) => {
  const { t } = useTranslation()
  const total = male + female + other
  const hasStudents = total > 0

  return (
    <div className='d-flex h-100 w-100'>
      {hasStudents ? (
        <div className='min-w-0 h-100'>
          <Pie
            options={{
              animation: { animateRotate: false },
              plugins: {
                tooltip: { enabled: false },
                legend: { display: false },
              },
              responsive: true,
              maintainAspectRatio: false,
            }}
            data={{
              datasets: [
                {
                  data: [male, female, other],
                  backgroundColor: [globals.darkBlue, globals.primaryOrange, globals.darkGray],
                },
              ],
            }}
          />
        </div>
      ) : (
        <div className={classes.placeholder} />
      )}
      <div className={classnames('d-flex flex-column justify-content-center', classes.legendHalf)}>
        <div className={classes.statsItem}>
          <div className='d-flex align-items-center'>
            <div className={classnames(classes.dot, classes.blue)} />
            {t('common.gender.male')}
          </div>
          <span>{hasStudents ? numbersToPercentage(male, total, true) : '0%'}</span>
        </div>
        <div className={classes.statsItem}>
          <div className='d-flex align-items-center'>
            <div className={classnames(classes.dot, classes.orange)} />
            {t('common.gender.female')}
          </div>
          <span>{hasStudents ? numbersToPercentage(female, total, true) : '0%'}</span>
        </div>
        <div className={classes.statsItem}>
          <div className='d-flex align-items-center'>
            <div className={classnames(classes.dot, classes.gray)} />
            {t('common.gender.other')}
          </div>
          <span>{hasStudents ? numbersToPercentage(other, total, true) : '0%'}</span>
        </div>
      </div>
    </div>
  )
}

GenderBreakdownPie.propTypes = {
  male: PropTypes.number,
  female: PropTypes.number,
  other: PropTypes.number,
}

export default GenderBreakdownPie
